<template>
  <div class="home">

    
    
    <!--Banner Wrap Start-->
    <div class="kode_banner">

        
        <div class="text-center">
            <div id="carousel" class="carousel slide carousel-fade" data-ride="carousel">
                <ol class="carousel-indicators">
                    <li data-target="#carousel" data-slide-to="0" class="active">111</li>
                    <li data-target="#carousel" data-slide-to="1">asdasdasd</li>
                    <li data-target="#carousel" data-slide-to="2">asdasdasdasd</li>
                </ol>
                <!-- Carousel items -->
                <div class="carousel-inner">

                    <div v-for="(data, idx) in slider" :key="data.id" :class="cek_active(idx) +' item'"  >
                        <img :src="file_path+data.foto" alt="Banner Image Here" class="img-responsive full-sc">
                    </div>
                </div>
                <!-- Carousel nav -->
                <a class="carousel-control left" href="#carousel" data-slide="prev">&lsaquo;</a>
                <a class="carousel-control right" href="#carousel" data-slide="next">&rsaquo;</a>
            </div>

        </div>









        <div>
            <div class="" style="position: absolute; z-index: 999;   margin: 0 auto;   left: 0;  right: 0; top: 93%;  text-align: center;width:90%">
                <div class="row" style="overflow: auto; " >
                    <div class="col-md-4 col-sm-4 col-lg-4 text-center" style=" background-color:#ef4a2b;float: left;padding: 5px 0px 5px 0px !important;color:#fff" >
                        <i class="fa fa-bullhorn" aria-hidden="true"></i> <b> PENGUMUMAN</b>
                    </div>
                    <div class="col-md-8 col-sm-8 col-lg-8" style=" background-color:#fff;padding: 2px 0px 2px 0px !important;float: auto">
                        <marquee behavior="" direction=""> <a href="" style="color:#000" v-for="data in pengumuman" :key="data.id"> <span  > 
                            <router-link to="/pengumuman">
                                {{'#'+ data.judul + ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'}}
                            </router-link>
                            </span></a>
                        </marquee>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--Banner Wrap End-->
    
    
    <!--Content Wrap Start-->
    <div class="kode_content">




<!-- Modal -->
<div class="modal fade" id="modalInfoGrafis" role="dialog" aria-labelledby="modalInfoGrafis" style="margin-top:100px; ">
    <div class="modal-dialog modal-md" role="document"  style="z-index:1024 !important;">
        <div class="modal-content" >
        <div class="modal-header" >
            <button @click="closeVideo('videoGrafis')" type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h6 class="modal-title" id="modalInfoGrafis" ><small><b>DISDUKCAPIL KONAWE SELATAN</b></small></h6>
        </div>
        <div class="modal-body"  style="z-index:9999 !important;">


            <div id="videoGrafis">
                <video style="width:100%" autoplay controls>
                <source :src="file_path+'opening.mp4'" type="video/mp4">
                <source :src="file_path+'opening.mp4'" type="video/ogg">
                Your browser does not support the video tag.
                </video>

            </div>



            

        </div>
        <div class="modal-footer" >
            <button type="button" class="btn btn-default"  @click="closeVideo('videoGrafis')" data-dismiss="modal" style="background-color:#ef4a2b;color:#fff">Close</button>
        </div>
        </div>
    </div>
</div>

















    
    	<!--Program List Wrap Start-->
        <div class="kode_program_bg" style="z-index:-2">
            <div class="col-md-4" >
                <div class="kode_program_list">
                    <figure>
                        <img src="images/11.png" alt="Image Here" style="width:100%;height:250px">
                    </figure>
                    <div class="kode_program_des">
                    	<h5>Profil Kependudukan</h5>
                        <!-- <p>The Era to remove the corruption</p> -->
                        <br>
                        <i class="fa fa-book" aria-hidden="true"></i>
                    </div>
                    
                    <div class="kode_program_hover">
                    	<h5>Buku Profil Kependudukan</h5>
                        <p>Lihat buku profil kependudukan. </p>
                        <router-link class="kode_link_2" to="/profil_kependudukan">Selengkapnya</router-link>
                    </div>
                    
                </div>
            </div>
            
            <div class="col-md-4" style="z-index:2">
                <div class="kode_program_list" style="z-index:-2">
                    <figure>
                        <img src="images/12.png" alt="Image Here" style="width:100%;height:250px">
                    </figure>
                    <div class="kode_program_des">
                    	<h5>Data Agregat Kependudukan</h5>
                        <p> </p>
                        <i class="fa fa-book" aria-hidden="true"></i>
                    </div>
                    
                    <div class="kode_program_hover">
                    	<h5>Data Agregat Kependudukan</h5>
                        <p>Lihat Data Agregat Kependudukan</p>
                        <router-link class="kode_link_2" to="/data_agregat_kependudukan">Selengkapnya</router-link>
                    </div>
                    
                </div>
            </div>
            
            <div class="col-md-4">
                <div class="kode_program_list">
                    <figure>
                        <img src="images/13.png" alt="Image Here" style="width:100%;height:250px">
                    </figure>
                    <div class="kode_program_des">
                    	<h5>JDIH</h5>
                        <p>Jaringan Dokumentasi dan Informasi Hukum</p>
                        <i class="fa fa-book"></i>
                    </div>
                    
                    <div class="kode_program_hover">
                    	<h5>JDIH</h5>
                        <p>Jaringan Dokumentasi dan Informasi Hukum </p>
                        <a class="kode_link_2" href="http://jdih.konaweselatankab.go.id/" target="_blank">Selengkapnya</a>
                    </div>
                    
                </div>
            </div>
        </div>
        <!--Program List Wrap Start-->
                
        <!--Welcome to Democracy Wrap Start-->
        <section class="kode_about_welcome">
            <div class="container">
            	<div class="row">
                    <div class="col-md-5">
                        <div class="kode_welcome">
                            <figure>
                                <img :src="file_path+sambutan_foto" alt="Image Here">
                            </figure>
                        </div>
                    </div>

                    <!-- this.sambutan_nama = data.nama;
            this.sambutan_foto = data.foto;
            this.sambutan_isi = data.isi; -->

                
                    <div class="col-md-7">
                        <div class="kode_wel_demo_des">
                            <h6>Kepala Dinas Kependudukan dan Catatan Sipil</h6>
                            <h4>{{sambutan_nama}}</h4>
                        </div>
                            <span style="font-size:60%" v-html="sambutan_isi"></span>
                    </div>
                    
            	</div>
            </div>
        </section>
        <!--Welcome to Democracy Wrap End-->

        <!--News & Press Release Wrap Start-->
        <section class="kode_news_bg" style="margin-top:-50px">
        	<div class="container">
            	<div class="kode_hdg_1">
                	<!-- <h6>Media  Conference</h6> -->
                    <h6>Index Kepuasan Masyarakat</h6>
                    <h4>(IKM ONLINE) </h4>
                </div>
                
                <div class="kode_press_new_lst">
                    <div class="row">
                        <div class="col-12 col-md-6" style="padding-left:2%; padding-right:2%; padding-bottom:0.5%">
                            <span class="h_lable ">Tahun</span>
                            <select @change="getAllIKM()"  v-model="tahun">
                                <option v-for="(data, index) in list_tahun" :key="index" :value="data">{{data}}</option>
                            </select>
                        </div>

                        <div class="col-12 col-md-6" style="padding-left:2%; padding-right:2%; padding-bottom:0.5%">
                            <span class="h_lable ">Semester</span>
                            <select @change="getAllIKM()" v-model="semester">
                                <option value="1">Semester I</option>
                                <option value="2">Semester II</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 col-sm-6 text-center padding-vertical">
                            <div style="background:#FF8A65" class="padding-vertical1">
                                <div class="h_title_questioner">Kuesioner</div>
                                <div class="h_value_questioner">{{dataDashboarku.juml_kesioner}}</div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6 text-center padding-vertical">
                            <div style="background:#E57373" class="padding-vertical1">
                                <div class="h_title_questioner">Responden</div>
                                <div class="h_value_questioner">{{jmlResponden}}</div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6 text-center padding-vertical ">
                            <div style="background:#EF4A2B" class="padding-vertical1">
                                <div class="h_title_questioner">Predikat</div>
                                <div class="h_value_questioner">
                                    {{nilaiIKM}} 
                                    <span class="h_sub_value_questioner">({{uraianIKM}})</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kode_press_link">
                	<a href="https://survei.disdukcapil.konaweselatankab.go.id/#/" class="kode_link_2" to="/berita">Yuk Isi Survey 😊</a>
                </div>                
            </div>
        </section>
        <!--News & Press Release Wrap End-->

        
        <!--News & Press Release Wrap Start-->
        <section class="kode_news_bg">
        	<div class="container">
            	<div class="kode_hdg_1">
                	<!-- <h6>Media  Conference</h6> -->
                    <h4>Berita</h4>
                </div>
                
                <div class="kode_press_new_lst">
                    <div class="row">
                        <div class="col-md-4 col-sm-6" v-for="data in berita" :key="data.id">
                            <div class="kode_press_news">
                                <figure class="kode_pres1_style">
                                    <img :src="file_path+data.foto"  alt="Image here" style="display: block;width: 100%;height: 300px">
                                    <!-- <figcaption><a data-rel="prettyPhoto[]" href="extra-images/banner-01.jpg"><i class="icon-add52"></i></a></figcaption> -->
                                </figure>
                                <div class="kode_news_date">
                                    <ul>
                                        <li> <a href="#"><b>{{convert_tgl(data.createAt)}}</b> </a></li>                                 
                                    </ul>
                                </div>
                                <div class="kode_news_des">
                                    <h6><a href="javascript:void(0);" @click="push_berita(data.id)">{{data.judul}}</a></h6>
                                    <p>{{limit_desk_berita(data.deskripsi)}} ...</p>
                                    <a href="javascript:void(0);" @click="push_berita(data.id)">Selengkapnya <i class="fa fa-long-arrow-right"></i> </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kode_press_link">
                	<router-link class="kode_link_2" to="/berita">Selengkapnya</router-link>
                </div>                
            </div>
        </section>
        <!--News & Press Release Wrap End-->
        
        
        <!--Our Latest Work Wrap Start-->
        <section class="kode_news_bg">
        	<div class="container">
            	<div class="kode_hdg_1">
                	<!-- <h6>Media  Conference</h6> -->
                    <h4>Kegiatan</h4>
                </div>
                
                <div class="kode_press_new_lst">
                    <div class="row">
                        <div class="col-md-4 col-sm-6" v-for="data in kegiatan" :key="data.id">
                            <div class="kode_press_news">
                                <figure class="kode_pres1_style">
                                    <img :src="file_path+data.foto"  alt="Image here" style="display: block;width: 100%;height: 300px">
                                    <!-- <figcaption><a data-rel="prettyPhoto[]" href="extra-images/banner-01.jpg"><i class="icon-add52"></i></a></figcaption> -->
                                </figure>
                                <div class="kode_news_date">
                                    <ul>
                                        <li> <a href="#"><b>{{convert_tgl(data.createAt)}}</b> </a></li>                                 
                                    </ul>
                                </div>
                                <div class="kode_news_des">
                                    <h6><a href="javascript:void(0);" @click="push_kegiatan(data.id)">{{data.nama}}</a></h6>
                                    <p v-html="data.deskripsi">...</p>
                                    <a href="javascript:void(0);" @click="push_kegiatan(data.id)" >Selengkapnya <i class="fa fa-long-arrow-right"></i> </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kode_press_link">
                	<router-link class="kode_link_2" to="/kegiatan">Selengkapnya</router-link>
                </div>                
            </div>
        </section>
        <!--Our Latest Work Wrap End-->
        
        
        <!--Purchase Now Wrap Start-->
        <section class="kode_purchase_bg" style="background-image:url('./images/ratusan-pembeli-tiket-berdesakan-mengantri-di-loket-stasiun-lempuyangan-_110905200609-949.jpg')">
        	
            
            
            <div class="container">
            	<div class="kode_purchase">
                	<!-- <h6>See the Awesome Feature</h6> -->
                    <img src="images/KonaweSelatan.png" alt="" style="width:8%;padding:1%;" >
                    <h4>Dinas Kependudukan dan Pencatatan Sipil</h4>
                    <!-- <a class="kode_link_2" href="#">Purchase Now</a> -->
                </div>
            </div>
        </section>
        <!--Purchase Now Wrap End-->
        
        
 
        
        
        <!--Our Top Politician Wrap Start-->
        <section class="kode_top_politician_bg">
        	<div class="container">
            	<div class="kode_hdg_1">
                	<!-- <h6>Our people</h6> -->
                    <h4>Data Pegawai</h4>
                </div>
                
                <div class="row">
                	<div class="col-md-4 col-sm-6" v-for="data in data_pegawai" :key="data.id">
                    	<div class="kode_politician">
                        	<figure>
                            	<img :src="file_path+data.foto" alt="Image Here" style="display: block;width: 100%;height: 350px">
                                <figcaption class="kode_poli_img_des">
                                    <p>{{data.trackr}}</p>
                                </figcaption>
                            </figure>
                            <div class="kode_politician_des">
                            	<h6>{{data.nama}}</h6>
                                <p>{{data.jabatan}}</p>
                            </div>                    
                        </div>
                    </div>                    
                </div>
            </div> 
            <div class="kode_press_link">
                <router-link class="kode_link_2" to="/data_pegawai">Selengkapnya</router-link>
            </div>
        </section>
        <!--Our Top Politician Wrap End-->
 
        
        <!--Count Up Wrap Start-->
        <section class="kode_countup_bg" style="background-image:url('./images/ratusan-pembeli-tiket-berdesakan-mengantri-di-loket-stasiun-lempuyangan-_110905200609-949.jpg')">
        	<div class="container">

            	<div class="row" v-for="data in jumlah_penduduk" :key="data.id">
                	<div class="col-md-3 col-sm-6" >
                    	<div class="kode_countup">
                        	<i class="fa fa-male"></i>
                            <h3 class="counter">Pria</h3>
                            <p>{{data.pria + ' Jiwa'}}</p>
                        </div>
                    </div>
                    
                    <div class="col-md-3 col-sm-6" >
                    	<div class="kode_countup">
                        	<i class="fa fa-female"></i>
                            <h3 class="counter">Wanita</h3>
                            <p>{{data.wanita + ' Jiwa'}}</p>
                        </div>
                    </div>
                    
                    <div class="col-md-3 col-sm-6" > 
                    	<div class="kode_countup">
                        	<i class="fa fa-users"></i>
                            <h3 class="counter">Lansia</h3>
                            <p>{{data.lansia + ' Jiwa'}}</p>
                        </div>
                    </div>
                    
                    <div class="col-md-3 col-sm-6" >
                    	<div class="kode_countup">
                        	<i class="fa fa-child"></i>
                            <h3 class="counter" style="font-size:25px"> Umur Bawah 18 Tahun</h3>
                            <p>{{data.umurbawah + ' Jiwa'}} </p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
        <!--Count Up Wrap End-->    
    
    </div>
    <!--Content Wrap End-->
  </div>
</template>

<script>




// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

  import { Hooper, Slide } from 'hooper';
  import { VueAgile } from "vue-agile";
  import 'hooper/dist/hooper.css';


const SLIDER_URL = URL_APP + "api/v1/publish_slider/";
const SAMBUTAN_URL = URL_APP + "api/v1/publish_sambutan/";
const BERITA_URL = URL_APP + "api/v1/publish_berita/";
const DATA_PEGAWAI_URL = URL_APP + "api/v1/publish_data_pegawai/";
const KEGIATAN_URL = URL_APP + "api/v1/publish_kegiatan/";

const tentang1_URL = URL_APP + "api/v1/publish_tentang1/";
const misi_URL = URL_APP + "api/v1/publish_misi1/";
const visi_URL = URL_APP + "api/v1/publish_visi/";
const pengumuman_URL = URL_APP + "api/v1/publish_pengumuman/";
const jumlah_penduduk_URL = URL_APP + "api/v1/publish_jumlah_penduduk/";

const URL_IKM = URL_APP + "api/v1/publish_home/";




const FILE_LOAD = URL_APP+'uploads/';
// import { Carousel, Slide } from 'vue-carousel';


const jmlIndexPeluang = (datax) => {
    var data = datax.index_peluang;
    var nilai = 0;
    datax.forEach(el => {
        nilai = nilai + el.index_peluang
    });
    return nilai
}



const ikm = (datax) =>{
    var nIndexPeluang = jmlIndexPeluang(datax);
    var nIKM = nIndexPeluang * 25
    return nIKM.toFixed(1)
}


const uraian = (datax) =>{
    var data = ikm(datax);


    if (data >= 88.31) {
        return 'Sangat Baik'   
    }
    else if(data < 88.31 && data >= 76.61){
        return 'Baik'
    }
    else if(data < 76.61 && data >= 65.00){
        return 'Kurang Baik'
    }
    else if(data < 65.00 && data >= 25){
        return 'Tidak Baik'
    }

    else {
        return 'Buruk'
    }
}

const semesterNumber = (datax) =>{
    var data = parseInt(datax)
    if (data > 0 && data <= 6) {
        return '1'
    } else if (data >= 7 && data <= 12) {
        return '2'
    }
    else{
        return '-'
    }
}






export default {
  
    components: {
      Hooper,
      Slide,
      agile: VueAgile
    },

    data() {
    return {
		sambutan_nama: "",
		sambutan_foto: "",
		sambutan_isi: "",

		// active_car : '',
		isip : '',
		isi : '',
		isivisi : '',
		isimisi : '',
		isitentang : '',
        judulp : '',
        
        nama: '',
        nip: '',
        jabatan: '',
        foto : '',
        fotovisi : '',
        fotomisi : '',
        fototentang : '',

        keg_judul: '',
        keg_isi: '',

        pria : '',
        wanita: '',
        lansia : '',
        umurbawah : '',



		slider : [],
		kegiatan : [],
		pengumuman : [],
		berita : [],
		data_pegawai : [],
		kegiatan : [],
        jumlah_penduduk : [],
        
		prodHukUU : [],
		prodHukKepres : [],
		prodHukPermen : [],
		
		
		file_path : FILE_LOAD,

    //   list_data: [],
    //   page_first: 1,
    //   page_last: 0,
    //   cari_value: ""

        jmlResponden : '',
        dataDashboarku : {
          jml_user: 0,
          juml_kesioner: 0
        },

        nilaiIKM : 0,
        uraianIKM : '',
        tahun :'',
        semester : '',


        list_tahun : [2020,2021,2022,2023,2024,2025],


    };
  },
  
 
  methods:{
    slidecss:function () {
    $("#slideshow > li:gt(0)").hide();
    setInterval(function() { 
      $('#slideshow > li:first')
        .fadeOut(1500)
        .next()
        .fadeIn(1500)
        .end()
        .appendTo('#slideshow');
    },  6000);
    },
    // =====================

    
	getSlider: function() {
      fetch(SLIDER_URL, {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      })
        .then(res => res.json())
        .then(res_data => {
          	this.slider = res_data;
        });
    },
 

    getPengumuman: function() {
        fetch(pengumuman_URL + "get6", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
            this.pengumuman = res_data;
            //   console.log(res_data);
        });
    },
    
    getSambutan : function(){
        fetch(SAMBUTAN_URL , {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
        .then(res => res.json())
        .then(res_data => {
			//   this.jumlah_penduduk = res_data;
            //   console.log(res_data);
            var data = res_data[0];

            this.sambutan_nama = data.nama;
            this.sambutan_foto = data.foto;
            this.sambutan_isi = data.isi;


        });
    },
 

 

    getJumlah_Penduduk: function() {
        fetch(jumlah_penduduk_URL + "getOne", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
        .then(res => res.json())
        .then(res_data => {
			  this.jumlah_penduduk = res_data;
			//   console.log(res_data);
        });
    },    

    getBerita: function() {
        fetch(BERITA_URL + "get3", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
        .then(res => res.json())
        .then(res_data => {
			  this.berita = res_data;
			//   console.log(res_data);
        });
    },    

    getKegiatan: function() {
        fetch(KEGIATAN_URL + "get3", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
        .then(res => res.json())
        .then(res_data => {
			  this.kegiatan = res_data;
            //   console.log(res_data);
            // var kegiatan = res_data[0];
            // this.keg_judul = kegiatan.judul;
            // this.keg_isi = kegiatan.judul;
        });
    },    


    getDataPegawai: function() {
        fetch(DATA_PEGAWAI_URL + "get3", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
        .then(res => res.json())
        .then(res_data => {
			  this.data_pegawai = res_data;
			//   console.log(res_data);
        });
    },

    getOnetentang: function() {
        fetch(tentang1_URL + "getOne", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
        .then(res => res.json())
        .then(res_data => { 
            var tentang1 = res_data[0];
            this.fototentang = tentang1.foto;    
            this.isitentang = tentang1.isi; 
        });
    },

    getOnemisi: function() {
        fetch(misi_URL + "getOne", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
        .then(res => res.json())
        .then(res_data => {
        var misi1 = res_data[0];
            this.fotomisi = misi1.foto;    
            this.isimisi = misi1.isi; 
        });
    },

    
    getOnevisi: function() {
        fetch(visi_URL + "getOne", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
        .then(res => res.json())
        .then(res_data => {
        var visi1 = res_data[0];
            this.fotovisi = visi1.foto;    
            this.isivisi = visi1.isi; 
        });
    },

    closeVideo(id){
        let containerElement = document.getElementById(id);
        let iframe_tag = containerElement.querySelector( 'iframe');
        let video_tag = containerElement.querySelector( 'video' );
        if ( iframe_tag) {
            let iframeSrc = iframe_tag.src;
            iframe_tag.src = iframeSrc; 
        }
        if ( video_tag) {
            video_tag.pause();
        }
    },

    // properti ------------------
        
        limit_desk : function(text){
            return text.substring(0, 250)
        },
        limit_desk_berita : function(text){
            return text.substring(0, 250)
        },    
        limit_desk_kegiatan : function(text){
            return text.substring(0, 250)
        },    
        limit_desk_about : function(text){
            return text.substring(0, 100)
        },    
        limit_desk_foto : function(text){
            return text.substring(0, 30)
        },

        cek_active_car : function(index){
            if (index == 0) {return 'active'}
            else{return ''}
        },


        push_berita : function(id){
            this.$router.push('/isi_berita/'+id);
        },
        push_kegiatan : function(id){
            this.$router.push('/isi_kegiatan/'+id);
        },
    // properti ------------------


    // ================== PAGINASI ====================
        alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
        },

        btn_prev: function() {
            if (this.page_first > 1) {
                this.page_first--;
            } else {
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next: function() {
        if (this.page_first >= this.page_last) {
            this.page_first == this.page_last;
        } else {
            this.page_first++;
        }
        this.getView();
        },

        cari_data: function() {
          this.getView();
        },
        onFileSelected : function(event){
            this.foto = event.target.files[0];
            // console.log(this.foto);
        },
        convert_tgl : function(dateString){
			var date = new Date(dateString);
			var bulan = "";

			if (date.getMonth() == 0) {bulan = 'januari';} 
			else if (date.getMonth() == 1) {bulan = 'Februari';}
			else if (date.getMonth() == 2) {bulan = 'Maret';}
			else if (date.getMonth() == 3) {bulan = 'April';}
			else if (date.getMonth() == 4) {bulan = 'Mei';}
			else if (date.getMonth() == 5) {bulan = 'Juni';}
			else if (date.getMonth() == 6) {bulan = 'Juli';}
			else if (date.getMonth() == 7) {bulan = 'Agustus';}
			else if (date.getMonth() == 8) {bulan = 'September';}
			else if (date.getMonth() == 9) {bulan = 'Oktober';}
			else if (date.getMonth() == 10) {bulan = 'November';}
			else if (date.getMonth() == 11) {bulan = 'Desember';}
			else{bulan = ''}

          return date.getDate()+" "+bulan+" "+date.getFullYear();
        },
        cek_active : function(data){
            if (data == 0) {
                return 'active'
            }
        },
    // ================== PAGINASI ====================


    getDashboard_IKM : function(){
      fetch(URL_IKM+'dashboard', {
          method: "GET",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
            // console.log(res_data);
           this.dataDashboarku = {
                jml_user: res_data.jml_user,
                juml_kesioner: res_data.juml_kesioner,
            }
      });
    },


    getChartIKM : function(){
      fetch(URL_IKM+'dashboard1', {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            tahun : this.tahun, 
            semester : this.semester
          })
      })
          .then(res => res.json())
          .then(res_data => {
            // console.log("ASSSUUUu");
            // console.log(res_data)
            this.listChart = res_data.data
            this.jmlResponden = res_data.jmlResponden



            setTimeout(() => {
              this.nilaiIKM = ikm(this.listChart);
              this.uraianIKM = uraian(this.listChart);
            }, 500);
      });
    },


    getAllIKM(){
        this.getDashboard_IKM();
        this.getChartIKM()
    }



  },
  mounted() {
      $('.carousel').carousel();
    this.slidecss();

    this.getSlider();
    this.getSambutan();
    this.getBerita();
    this.getDataPegawai();
    this.getKegiatan();
    this.getOnetentang();
    this.getOnemisi();
    this.getOnevisi();
    this.getPengumuman();
    this.getJumlah_Penduduk();


    // this.getDashboard_IKM();
    
    var date = new Date();
    this.tahun = date.getUTCFullYear();
    var bulan = date.getMonth();
    this.semester = semesterNumber(bulan+1)


    this.getAllIKM();
    setTimeout(() => {
        $('#modalInfoGrafis').modal('show');
        
    }, 1000);



  }

  
}

</script>
